import { useTranslation } from "react-i18next";
import timeOutError from "../../assets/images/pictograma-ampulheta-off.png";
import Header from "@/components/header/Header";

export default function ActionNotAuthorizedPage() {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-8">
      <form id="TimeOutError" autoComplete="off">
        <div className="flex justify-center">
          <Header
            title={t("action_not_authorized_page.title")}
            subtitle={t("action_not_authorized_page.subtitle")}
            isTextAlignCenter
          />
        </div>
      </form>
      <div className="flex justify-center">
        <img src={timeOutError} className="contact-center-icon" alt="" />
      </div>
    </div>
  );
}
